import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { ReferrerIdentity } from '@/lib/referral/referrerIdentity';

/**
 * Henvisers navn (public.users.name) and Henvisers titel
 * (clinic_memberships.title for the active membership in the patient's
 * clinic). The same source for XREF01, XREF02 and XREF06.
 */
export function useReferrerIdentity(userId: string | null | undefined, clinicId: string) {
  return useQuery({
    queryKey: ['referral-referrer', userId ?? null, clinicId],
    enabled: Boolean(userId),
    queryFn: async (): Promise<ReferrerIdentity> => {
      if (!userId) return { name: null, title: null };
      const [{ data: userRow, error: userError }, { data: membership, error: membershipError }] =
        await Promise.all([
          supabase.from('users').select('name').eq('id', userId).maybeSingle(),
          supabase
            .from('clinic_memberships')
            .select('title')
            .eq('user_id', userId)
            .eq('clinic_id', clinicId)
            .eq('status', 'active')
            .maybeSingle(),
        ]);
      if (userError) throw userError;
      if (membershipError) throw membershipError;
      return { name: userRow?.name ?? null, title: membership?.title ?? null };
    },
    staleTime: 60_000,
  });
}
